import { Injectable, Injector } from '@angular/core';
import {
    HttpInterceptor,
    HttpHandler,
    HttpEvent,
    HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { LocaleHelperService } from '@finder/shared/services/locale-service/locale-helper.service';
import { CONFIG_CONSTANTS, LOCALE_DEFAULT } from '@finder/shared/constants/app.constants';
import { environment } from 'environments/environment';
import { ConfigService } from '@finder/core/config.service';

@Injectable()
export class TranslationInterceptor implements HttpInterceptor {

    constructor(private injector: Injector) { }

    /**
     * [PRO-346388]
     * This can be removed once WorldServer is ready
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const localeHelperService = this.injector.get(LocaleHelperService);
        const splitValue = 'finder/api';
        const locale = localeHelperService.getUriLocale() || LOCALE_DEFAULT;
        const isDefaultLocale = localeHelperService.isDefaultLocale(locale);
        const skipTranslation = this.skipTranslation(req, splitValue, isDefaultLocale);

        // If we are in local dev don't bother
        if (environment.production === false) {
            return next.handle(req);
        }

        // Do not translate if any condition is met
        if (skipTranslation) {
            return next.handle(req);
        }

        // No locale detected. Return normal request
        if (!locale) {
            return next.handle(req);
        }

        req = this.createNewRequest(req, splitValue, locale);

        return next.handle(req);
    }

    private createNewRequest(req: HttpRequest<any>, splitValue: string, locale: string) {
        // Create the new uri
        const localeUrl = req.url.replace(splitValue, `${locale}/${splitValue}`);

        // Create the new request
        return req.clone({ url: localeUrl });
    }

    skipTranslation(req: HttpRequest<any>, splitValue: string = '', isDefaultLocale: boolean = false) {
        const configService = this.injector.get(ConfigService);
        const allowedLocations = ['wdw'];
        const skipTranslation = [
            // non finder call
            !req.url.includes(splitValue),
            // site does not require translation
            !allowedLocations.includes(configService.getValue(CONFIG_CONSTANTS.siteIdKey)),
            // english/GDPR locale
            isDefaultLocale,
            // authz call
            req.url.includes('authz'),
        ];

        // Do not translate if any condition is met
        if (skipTranslation.includes(true)) {
            return true;
        }

        return false;
    }
}
